module.exports = __webpack_public_path__ + "static/media/pastasarrocesy.2dd1946b.svg";